import React from 'react';
import { useAppSelector } from 'store/hook';
import { useResponsive } from 'antd-style';
import MenuIcon from 'ui-component/icons/menu';
import ProfileSection from './ProfileSection';
import { useStyles } from './index.style';

interface IHookProps {
  onOpen: () => void;
}

const Header: React.FC<IHookProps> = ({ onOpen }) => {
  const { styles } = useStyles();
  const { laptop } = useResponsive();
  const title = useAppSelector((state) => state.page.title);
  return (
    <div className={styles.container}>
      <div className={styles.left}>
        {!laptop ? (
          <div className={styles.menu} onClick={onOpen}>
            <MenuIcon width="30px" height="30px" />
          </div>
        ) : null}
        {title ? <div className={styles.title}>{title}</div> : null}
      </div>
      <ProfileSection />
    </div>
  );
};

export default Header;
